import ApplicationController from '../application_controller';

/* global $ */
export default class extends ApplicationController {
  connect() {
    this.form = this.element.querySelector('#registro_observaciones_form');
    this.titulo = this.element.querySelector('.modal-title');
    this.botonGuardar = this.element.querySelector('.btn-guardar-registro');
    this.$modal = $(this.element);

    this.boundOnDocumentClick = this.#onDocumentClick.bind(this);
    this.boundOnGuardarClick = this.#onGuardarClick.bind(this);
    this.boundOnModalHidden = this.#onModalHidden.bind(this);
    this.boundOnSubmitStart = this.#onSubmitStart.bind(this);
    this.boundOnSubmitEnd = this.#onSubmitEnd.bind(this);

    document.addEventListener('click', this.boundOnDocumentClick);
    this.botonGuardar?.addEventListener('click', this.boundOnGuardarClick);
    this.$modal.on('hidden.bs.modal', this.boundOnModalHidden);
    this.form?.addEventListener('turbo:submit-start', this.boundOnSubmitStart);
    this.form?.addEventListener('turbo:submit-end', this.boundOnSubmitEnd);
  }

  disconnect() {
    document.removeEventListener('click', this.boundOnDocumentClick);
    this.botonGuardar?.removeEventListener('click', this.boundOnGuardarClick);
    this.$modal.off('hidden.bs.modal', this.boundOnModalHidden);
    this.form?.removeEventListener('turbo:submit-start', this.boundOnSubmitStart);
    this.form?.removeEventListener('turbo:submit-end', this.boundOnSubmitEnd);
  }

  #onDocumentClick(event) {
    const botonNuevo = event.target.closest('.abrir-modal-nuevo-registro');
    if (botonNuevo) {
      event.preventDefault();
      this.#prepararNuevo(botonNuevo);
      this.$modal.modal('show');
      return;
    }

    const botonClonar = event.target.closest('.clonar-registro-observaciones');
    if (botonClonar) {
      event.preventDefault();
      this.#prepararClonar(botonClonar);
      this.$modal.modal('show');
    }
  }

  #prepararNuevo(boton) {
    this.#resetFormulario();
    this.titulo.textContent = this.element.dataset.tituloNuevo || 'Nuevo';
    this.form.action = boton.dataset.formUrl;
  }

  #prepararClonar(boton) {
    this.#resetFormulario();

    const curso = boton.dataset.curso || '';
    const evaluacion = boton.dataset.evaluacion || '';
    this.titulo.innerHTML = `Clonar <small>${curso} / ${evaluacion}</small>`;

    const modelo = boton.dataset.model ? JSON.parse(boton.dataset.model) : {};
    const nombreInput = this.form.querySelector('[name="registro_observaciones[nombre]"]');
    const tipoSelect = this.form.querySelector('[name="registro_observaciones[tipo]"]');
    if (nombreInput && modelo.nombre) {
      nombreInput.value = modelo.nombre;
    }
    if (tipoSelect && modelo.tipo) {
      tipoSelect.value = modelo.tipo;
    }

    this.form.action = boton.dataset.formUrl;
  }

  #resetFormulario() {
    this.form.reset();
    this.#limpiarSelectorEstructura();
    const evaluacionSelect = this.form.querySelector('.evaluacion-selector');
    if (evaluacionSelect) {
      evaluacionSelect.innerHTML = '';
      const option = document.createElement('option');
      option.value = '';
      option.text = '';
      evaluacionSelect.add(option);
    }
  }

  #limpiarSelectorEstructura() {
    const wrapper = this.element.querySelector('.selector-estructura-wrapper');
    if (wrapper) {
      wrapper.dispatchEvent(new CustomEvent('limpiar-seleccion'));
    }
  }

  #onGuardarClick() {
    this.form?.requestSubmit();
  }

  #onModalHidden(event) {
    if (event.namespace !== 'bs.modal') return;
    this.#resetFormulario();
    this.#habilitarGuardar();
  }

  #onSubmitStart(event) {
    if (event.target !== this.form) return;
    this.#deshabilitarGuardar();
  }

  #onSubmitEnd(event) {
    if (event.target !== this.form) return;
    this.#habilitarGuardar();
  }

  #deshabilitarGuardar() {
    if (this.botonGuardar) {
      this.botonGuardar.disabled = true;
    }
  }

  #habilitarGuardar() {
    if (this.botonGuardar) {
      this.botonGuardar.disabled = false;
    }
  }
}
